import React from 'react';
import styled from 'styled-components/macro';
import { usePage } from '../../../contexts/pageContext';
import { useNomenclator } from '../../../contexts/nomenclatorContext';
import { nombreEleccion } from '../../../resources/constantes.json';
import Spinner from '../../../components/Spinner';
const Mapa = React.lazy(() => import('../../Mapa'));

const ResumenPorTerritorios = ({ camaraSeleccionada, setDimensions }) => {
  const pageState = usePage();
  const nomenclator = useNomenclator();
  const { data, urlInfo } = pageState;
  const { id, eleccion, idHistorico } = urlInfo;
  const esHistorico = idHistorico != null;
  const ambito = nomenclator.ambitos[eleccion][id];
  const citrep = nombreEleccion[eleccion] === 'citrep';
  return (
    <article>
      <React.Suspense fallback={<Spinner />}>
        <Mapa
          variant="resultados"
          amb={ambito.c}
          data={data}
          nomenclator={nomenclator}
          ambito={ambito}
          esHistorico={esHistorico}
          camaraSeleccionada={camaraSeleccionada}
          eleccion={eleccion}
          citrep={citrep}
          {...urlInfo}
        />
      </React.Suspense>
    </article>
  );
};

// eslint-disable-next-line no-unused-vars
const SH3 = styled.h3`
  text-align: center;
  font-weight: bold;
  color: #1c4183;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
`;

export default ResumenPorTerritorios;
